import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Message } from 'primeng/components/common/api';
import { UserService } from '../../../services/user/user.service';
import { AuthenticationService } from '../../../services/authentication/authentication.service';

@Component({
    selector: 'app-verify-phone',
    templateUrl: './verify-phone.component.html',
    styleUrls: ['./verify-phone.component.css']
})

export class VerifyPhoneComponent implements OnInit {
    queryParams: Params;
    messages: Message[];
    loading = false;
    userId = '';
    model: { Code: string, UserId: string } = { Code: null, UserId: this.userId };
    constructor(
        private activatedRoute: ActivatedRoute,
        private userService: UserService,
        private auth: AuthenticationService,
        private router: Router) { }

    ngOnInit() {
        this.model.UserId = this.auth.getUser().userId;
        this.activatedRoute.queryParams.subscribe(params => {
            if (Object.keys(params).length) {
				this.model.Code = params['code'];
				this.model.UserId = params['userId'];
            }
            this.queryParams = params;
        });
    }

    goBack(): void {
        this.router.navigate(['/profile']);
    }

    confirm() {
        this.loading = true;
        this.userService.verifyPhone(this.model)
            .subscribe(res => {
                this.router.navigate(['/profile', 'edit']);
				this.loading = false;
				this.messages = [];
                this.messages.push({ severity: 'success', summary: 'Verified', detail: 'Phone number verified.' });
            }, error => {
				this.router.navigate(['/profile', 'edit']);
				this.loading = false;
				this.messages = [];
                this.messages.push({ severity: 'error', summary: 'Error', detail: error });
			});
    }
}



// WEBPACK FOOTER //
// ./src/app/components/users/verify-phone/verify-phone.component.ts